import { Link } from "react-router-dom";

import picMobile from "../../assets/images/pic/mobile.png";

export const IntroSection = () => {
  return (
    <section id="hero" className="d-flex align-items-center">
      <div className="container">
        <div className="row">
          <div
            className="col-lg-6 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-2 order-lg-1"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <h1>Realize your full potential in tech</h1>
            <h2>
              Value addition and excellence is what defines us, join this great team to experience a life changing
              career into tech
            </h2>
            <div className="d-flex justify-content-center justify-content-lg-start">
              <Link to="/#enrollNowBtn" className="btn-get-started scrollto" style={{ textDecoration: "none" }}>
                Get Started
              </Link>
            </div>
          </div>
          <div className="col-lg-6 order-1 order-lg-2 hero-img" data-aos="zoom-in" data-aos-delay="200">
            <img src={picMobile} className="img-fluid animated" alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};
